import { sentenceItem } from "../models/interfaces";

export const getOwnership = (sentences: sentenceItem[] ) => {
const initailList = sentences.map((ele) => {
      const localArray = ele.burden_attribution.filter((ele) => ele !== 'None');
      return localArray;
    });
    const finalSet = Array.from(new Set(initailList.flat()));
    return finalSet;
    
}